import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'
import { getMileageUnit } from 'core/utils/cultures/unit'
import { Slider } from 'core/components/ui'
import { font } from 'assets/themes/theme-default'
import FilterTitle from '../title'

const CustomSlider = styled(Slider)`
  .ant-slider-mark-text {
    font-size: ${font.size.sm};
  }
`

const SliderWrapper = styled.div`
  padding: 0 20px 5px;
`

const Mileage = props => {
  const [currentValues, setCurrentValues] = useState([])

  const { intl, onChangeFilter, filters, filtersDatas } = props

  const { mileageMin, mileageMax } = filters
  const mileagesList = filtersDatas.mileages

  const formatter = value => {
    const intlValue = intl.formatNumber(value)
    return `${intlValue} ${getMileageUnit()}`
  }

  const marks = {}
  const maxValue = currentValues[1]
  const minValue = currentValues[0]

  marks[maxValue] = formatter(maxValue)
  marks[minValue] = formatter(minValue)

  const onChange = value => {
    setCurrentValues(value)
  }

  const handleOnChangeFiltre = item => {
    const [min, max] = item

    const extendedFiltersValues = {
      ...filters,
      mileageMin: min,
      mileageMax: max
    }

    onChangeFilter(extendedFiltersValues)
  }

  useEffect(() => {
    const values = []

    if (mileagesList) {
      const maxVal = mileageMax || mileagesList.max
      const minVal = mileageMin || mileagesList.min

      values[0] = minVal
      values[1] = maxVal
    }

    setCurrentValues(values)
  }, [])

  return (
    <div data-test="component-stock-vehicles-list-filters-mileage">
      <FilterTitle
        label={intl.formatMessage({
          id: 'stock-vehicles-list-filters-mileage-title'
        })}
        data-test="stock-vehicles-list-filters-mileage-title"
      />
      <SliderWrapper>
        {mileagesList && (
          <CustomSlider
            defaultValue={currentValues}
            max={mileagesList.max}
            min={mileagesList.min}
            step={mileagesList.step}
            range
            marks={marks}
            onAfterChange={value => handleOnChangeFiltre(value)}
            onChange={value => onChange(value)}
            tooltipVisible={false}
            data-test="stock-vehicles-list-filters-mileage-slider"
          />
        )}
      </SliderWrapper>
    </div>
  )
}

Mileage.propTypes = {
  filtersDatas: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  intl: PropTypes.shape().isRequired
}

export default injectIntl(Mileage)
